import React from 'react'
import { ChevronDown } from 'react-feather'
import Dropdown from 'react-dropdown';
import './header-dropdown.css';
import { useSystem } from '../../features/system/hook';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedAudience } from '../../features/system/slice';
import { useHistory, useLocation } from 'react-router-dom';

const forEveryoneLabel = {
  id: 'SEMUA ORANG',
  en: 'FOR EVERYONE'
}

const AudienceDropdown = () => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const {
    uppercasedAudienceOptions,
    uppercasedAudienceOptionsMap,
  } = useSystem()
  const uppercased = uppercasedAudienceOptions
  const finalOptions = uppercased

  const selectedAudience = useSelector(state => state.system.selectedAudience)
  const { audiencesById, language, selectedAudienceId } = useSelector(state => state.system)
  const [show, setShow] = React.useState(true)
  const currentParams = new URLSearchParams(location.search)
  const currentId = currentParams.get('audience')

  React.useEffect(() => {
    if(currentId !== selectedAudienceId){
      setShow(false)

      if(parseInt(currentId) === 1 || currentId === null){
        dispatch(setSelectedAudience({
          label: forEveryoneLabel[language.name],
          value: forEveryoneLabel[language.name],
          id: 1
        }))
      } else {
        const obj = audiencesById[currentId]
        if(obj && obj.name && obj.name[language.name]){
          const name = obj.name[language.name].toUpperCase()
          dispatch(setSelectedAudience({label: name, value: name, id: parseInt(currentId)}))
        }
      }

      setTimeout(() => setShow(true), 100)
    }
    //eslint-disable-next-line
  }, [currentId, selectedAudienceId, language])

  const handleChange = (e) => {
    const newId = uppercasedAudienceOptionsMap[e.value].id
    const newSelectedAudience = {
      ...e,
      id: newId
    }
    dispatch(setSelectedAudience(newSelectedAudience))

    if(currentId !== newId){
      let newRoute = location.pathname

      // Ignore "Semua Orang"
      if(newId === 1){
        currentParams.delete('audience')
      } else {
        currentParams.set('audience', newId)
      }

      history.push(newRoute+'?'+currentParams.toString())
    }
  }

  return (
    <div
      className="flex items-center border-l pl-8 relative"
      style={{borderColor: '#ddd'}}
    >
      <div className="flex items-center cursor-pointer">
        <ChevronDown
          style={{width: '16px', height: '16px', color: '#52BAE2'}}
          className="mr-2 absolute"
        />

        {
          show &&
          <Dropdown
            options={finalOptions}
            onChange={handleChange}
            value={selectedAudience}
            placeholder="Select an option"
            className="header-dropdown"
          />
        }
      </div>
    </div>
  )
}

export { AudienceDropdown }
